const state = {
  vehicles: {}
}

export default state


